import React from '../lib/react'
import { auth } from '../services/firebase/firebase.js'
import IconText from './IconText.js'

import './Like.less';

function isLiked(liked_users){
  const uid = auth().currentUser && auth().currentUser.uid;
  if (uid) {
    return liked_users.includes(uid)
  }

  return false
}

export default function(props){
  let { id, liked_users, localCount } = props;
  if (props.entry) {
    const entry = props.entry;
    id = entry.id;
    liked_users = entry.liked_users;
  }
  if (props.id && props.liked_users) {
    id = props.id;
    liked_users = props.liked_users
    localCount = props.localCount
  }

  const className = isLiked(liked_users) ? "like liked" : "like";
  const likesCountText = localCount || (liked_users && liked_users.length);

  return (
    <div
      onClick={() => props.handleLike(id)}
      className={className}
    >
      {
        props.component ? (
          <IconText component={props.component} text={likesCountText} />
        ) : (
          <IconText type="like-o" text={likesCountText} />
        )
      }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Like.js